var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"row"},[_c('section',{staticClass:"row-content"},[_c('span',[_vm._v(_vm._s(_vm.text))])]),_c('section',{staticClass:"row-action",on:{"click":_vm.handlerCopy}},[_c('AppIcon',{attrs:{"name":"copy","type":"IcoIcons"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }